import React from 'react';
import validator from 'validator';
import { Form, Formik, Field } from 'formik';
import AutocompleteLocalidad from '../Commons/AutocompleteLocalidad.jsx';
import { stringify } from 'rebem-classname';

export default function RenderFormPeriodista(props){
	const block = "RenderFormPublicar";

	let formContactarOMensaje = <Formik
		initialValues={{
			nombreApellido:'',
			telefono:'',
			email:'',
			mensaje:'',
		}}
		onSubmit={props.onSubmit}
		validate={({nombreApellido, telefono, email, localidad, mensaje})=>{
			let errores = {};
			if(!email){
				errores.email = 'El email es requerido';
			} else if(!validator.isEmail(email)){
				errores.email = 'El email ingresado no es valido';
			}
			if(!mensaje){
				errores.mensaje = 'El Comentario es requerido';
			} else if(mensaje.length>350) {
				errores.mensaje = 'El Comentario debe tener como maximo 350 caracteres';
			}
			if (!nombreApellido) {
				nombreApellido = 'Nombre es requerido';
			}
			if (!telefono) {
				telefono = 'Telefono es requerido';
			}
			return errores;
		}}
	>
		{({errors, touched}) => (<Form>
			<Field name="nombreApellido" placeholder="Nombre y Apellido * " className="" />
			{touched.nombreApellido && errors.nombreApellido && <div>{errors.nombreApellido}</div>}
			<Field name="telefono" type="tel" placeholder="Teléfono / Celular * " className=""/>
			{touched.telefono && errors.telefono && <div>{errors.telefono}</div>}
			<Field name="email" placeholder="Email " className=""/>
			{touched.email && errors.email && <div>{errors.email}</div>}
			<Field name="localidad">
				{({
					field: { value, onChange },
					form: { touched, errors, setFieldValue, values }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
					meta,
				}) => { 
					const onLugarClear = () => setFieldValue('localidad',null);
					const onLugarSelected = lugar => setFieldValue('localidad',lugar);
					const localidadConsultada = value;
					return <AutocompleteLocalidad
						onLugarClear={onLugarClear} 
						onLugarSelected={onLugarSelected}
						idProvincia={values && values.provincia ? values.provincia : null}
					/>
				}}
			</Field>
			{touched.localidad && errors.localidad && <div>{errors.localidad}</div>}
			<Field as="textarea"  maxLength="350" name="mensaje" placeholder="Mensaje (*)" className=""/>
			{touched.mensaje && errors.mensaje && <div>{errors.mensaje}</div>}
			<button type="submit" className="btn btn-naranja">Enviar</button>
		</Form>)}
	</Formik>;

	if (props.mostrarMensajeDeEnvio) {
		formContactarOMensaje = <div className={stringify({block, elem:"mensaje_ok"})}>
			<span>Muchas Gracias por su contacto. Nos comunicaremos a la brevedad</span>
			<span className={stringify({block, elem:"ok glyphicon glyphicon-ok"})}></span>
		</div>
	}

	return <div className={`container-fluid ${stringify({block})}`}>
		<div className={stringify({block, elem:"formularios"})}>
			{formContactarOMensaje}
		</div>
	</div>
}
